import React from "react";

const Card = ({ title, data }) => {
  return (
    <div className="card">
      <div className="wrapper">
        <p>{title && title}</p>
        <b>{data && data}</b>
      </div>
    </div>
  );
};

export default Card;
